import React, { useState, useEffect } from 'react'
import { CardBody, FormGroup, Form, Input, Button, Label } from 'reactstrap'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { Mail, Lock } from 'react-feather'
import axios from 'axios'

function ResetPasswordJWT({ setSuccessfull, token }) {
  const [email, setEmail] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [newPassword2, setNewPassword2] = useState('')
  const [error, setError] = useState('')

  const intl = useIntl()

  const handleResetPassword = async e => {
    e.preventDefault()

    if (!token) return setError('No token provided')

    if (newPassword !== newPassword2) {
      return setError('Passwords do not match')
    }
    if (newPassword.length < 6) {
      return setError('Password must be at least 6 characters long')
    }
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/reset-password`, {
        email,
        password: newPassword,
        token,
      })
      setSuccessfull(true)
    } catch (err) {
      setError(err.response.data.message)
    }
  }

  useEffect(() => {
    setError('')
  }, [email, newPassword, newPassword2])

  return (
    <>
      <CardBody className="pt-1">
        {error && (
          <div className="alert alert-danger">
            {intl.formatMessage({ id: error })}
          </div>
        )}

        <Form onSubmit={handleResetPassword}>
          <Label for="email">{intl.formatMessage({ id: 'Email' }) + ':'}</Label>
          <FormGroup className="position-relative has-icon-left">
            <Input
              type="email"
              id="email"
              placeholder={intl.formatMessage({ id: 'Your company email' })}
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
            <div className="form-control-position">
              <Mail size={15} />
            </div>
          </FormGroup>

          <Label for="password">
            {intl.formatMessage({ id: 'New password' }) + ':'}
          </Label>
          <FormGroup className="form-label-group position-relative has-icon-left">
            <Input
              id="password"
              type="password"
              placeholder={intl.formatMessage({ id: 'Password' })}
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              required
            />
            <div className="form-control-position">
              <Lock size={15} />
            </div>
          </FormGroup>

          <Label for="password-confirm">
            {intl.formatMessage({ id: 'Confirm your password' }) + ':'}
          </Label>
          <FormGroup className="form-label-group position-relative has-icon-left">
            <Input
              id="password-confirm"
              type="password"
              placeholder={intl.formatMessage({ id: 'Password' })}
              value={newPassword2}
              onChange={e => setNewPassword2(e.target.value)}
              required
            />
            <div className="form-control-position">
              <Lock size={15} />
            </div>
          </FormGroup>
          <div className="d-flex align-items-center">
            <Button.Ripple color="primary" type="submit">
              {intl.formatMessage({ id: 'Reset' })}
            </Button.Ripple>
            <Link className="ml-3" to="/login">
              {intl.formatMessage({ id: 'Go Back to Login' })}
            </Link>
          </div>
        </Form>
      </CardBody>
    </>
  )
}

export default ResetPasswordJWT
